import { debounce } from "../../../__compat__/lodash/main.entry.mjs.mjs";
import { useLayoutEffect } from "../../../__compat__/react/main.entry.mjs.mjs";
export const usePopoverLitePosition = ({ ref, alignment, open, }) => {
    useLayoutEffect(() => {
        const updateLeftPosition = () => {
            const popoverLite = ref.current;
            if (!popoverLite) {
                return;
            }
            const sibling = popoverLite.previousElementSibling;
            if (!sibling || !popoverLite) {
                return;
            }
            const bubblePadding = 16;
            /** @pM the page margin value. due to a chrome bug we cannot access the css variable from the browser here */
            let pM = 16;
            if (window.innerWidth > 375) {
                pM = 28;
            }
            if (window.innerWidth > 768) {
                pM = 40;
            }
            if (window.innerWidth > 1024) {
                pM = 60;
            }
            if (window.innerWidth > 1440) {
                pM = 96;
            }
            popoverLite.style.left = '';
            popoverLite.style.width = '';
            popoverLite.style.right = '';
            const left = Math.round(popoverLite.getBoundingClientRect().left);
            const width = Math.round(popoverLite.getBoundingClientRect().width);
            const siblingWidth = Math.round(sibling.getBoundingClientRect().width);
            const siblingLeft = Math.round(sibling.getBoundingClientRect().left);
            const siblingRight = Math.round(sibling.getBoundingClientRect().right);
            const leftWindowEdge = `-${siblingLeft - pM}px`;
            const leftPosForCenteredPopover = (width - siblingWidth) / 2;
            const overflowRightForCenteredPopover = siblingLeft - leftPosForCenteredPopover + width - window.innerWidth; // if positive, popover is overflowing to the right
            const overflowRightForLeftPopover = left + width - window.innerWidth;
            const leftPosForCenteredPopoverOverflowRight = leftPosForCenteredPopover + overflowRightForCenteredPopover + pM;
            const leftPosForLeftPopoverOverflowRight = overflowRightForLeftPopover + pM;
            const overflowLeft = siblingRight - width;
            const fullWidthDesktop = `calc(100vw - ${2 * bubblePadding + 2 * pM}px`;
            const windowInner = window.innerWidth;
            if (windowInner < 1024) {
                return (popoverLite.style.left = leftWindowEdge);
            }
            if (width > window.innerWidth - pM * 2) {
                return ((popoverLite.style.width = fullWidthDesktop),
                    (popoverLite.style.left = leftWindowEdge));
            }
            if (alignment === 'left') {
                if (overflowRightForLeftPopover > 0) {
                    return (popoverLite.style.left = `-${leftPosForLeftPopoverOverflowRight}px`);
                }
                return (popoverLite.style.left = '0');
            }
            if (overflowLeft < 0) {
                return (popoverLite.style.left = leftWindowEdge);
            }
            if (alignment === 'right') {
                return (popoverLite.style.right = '0');
            }
            if (overflowRightForCenteredPopover > 0) {
                return (popoverLite.style.left = `-${leftPosForCenteredPopoverOverflowRight}px`);
            }
            // Center alignment when sibling is wider than popover
            if (width < siblingWidth) {
                return (popoverLite.style.left = `${-1 * leftPosForCenteredPopover}px`);
            }
            // Default center alignment (popover wider than sibling)
            return (popoverLite.style.left = `-${leftPosForCenteredPopover}px`);
        };
        if (!open) {
            return;
        }
        const debouncedUpdateLeftPosition = debounce(updateLeftPosition, 200);
        updateLeftPosition();
        const handleResize = () => {
            debouncedUpdateLeftPosition();
        };
        window.addEventListener('resize', handleResize, { passive: true });
        return () => {
            window.removeEventListener('resize', handleResize);
            debouncedUpdateLeftPosition.cancel();
        };
    }, [ref, alignment, open]);
};
//# sourceMappingURL=use-popover-lite-position.mjs.mjs.map